export default __webpack_public_path__ + "static/media/onboarding_gifts_1.2730637f.png";